<ng-container [ngSwitch]="pageLoadingState$ | async">
  <ng-container *ngSwitchCase="LoadingState.Pending">
    <div class="flex mb-6">
      <span class="flex-1 ml-4">Setting up your properties...</span>
    </div>

    <div class="flex items-center justify-center mb-6">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="LoadingState.Success">
    <ng-container *ngIf="listingReviews$ | async; else reviewListingsNoData">
      <ng-template [ngTemplateOutlet]="reviewListingsV2"></ng-template>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="LoadingState.Error">
    <ng-template [ngTemplateOutlet]="reviewListingsError"></ng-template>
  </ng-container>
</ng-container>

<ng-template #reviewListingsNoData>
  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
    <div>
      <svg width="90" height="82" viewBox="0 0 90 82" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.47656 42.3789L40.9009 3.92191C42.0504 2.77921 43.607 2.14019 45.2278 2.14554C46.8486 2.15089 48.4009 2.80016 49.5429 3.95042L87.9998 42.3789"
          stroke="#E5E2E9"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M75.7819 30.169V79.0313H14.6938V30.1487"
          stroke="#E5E2E9"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33 43C33 44.6569 31.6569 46 30 46C28.3431 46 27 44.6569 27 43C27 41.3431 28.3431 40 30 40C31.6569 40 33 41.3431 33 43ZM63 43C63 44.6569 61.6569 46 60 46C58.3431 46 57 44.6569 57 43C57 41.3431 58.3431 40 60 40C61.6569 40 63 41.3431 63 43ZM37.9152 59.8545C37.1972 60.2678 36.2801 60.0209 35.8668 59.3029C35.4534 58.585 35.7004 57.6679 36.4183 57.2546C39.3867 55.5455 47.0985 53.4341 55.4995 57.6005C56.2417 57.9686 56.5449 58.8686 56.1768 59.6108C55.8088 60.353 54.9087 60.6562 54.1666 60.2882C46.8001 56.6348 40.1545 58.5651 37.9152 59.8545Z"
          fill="#D0CDD4" />
      </svg>
    </div>

    <h2>No listings found</h2>

    <span class="text-center">
      {{ 'CORE.PRODUCT_NAME' | transloco }} did not find any listings under this account.
      <br />
      You need at least one listing to test out the features available on {{ 'CORE.PRODUCT_NAME' | transloco }}.
    </span>

    <ng-template [ngTemplateOutlet]="complete"></ng-template>
  </div>
</ng-template>

<ng-template #reviewListingsError>
  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
    <div>
      <svg width="90" height="82" viewBox="0 0 90 82" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.47656 42.3789L40.9009 3.92191C42.0504 2.77921 43.607 2.14019 45.2278 2.14554C46.8486 2.15089 48.4009 2.80016 49.5429 3.95042L87.9998 42.3789"
          stroke="#E5E2E9"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M75.7819 30.169V79.0313H14.6938V30.1487"
          stroke="#E5E2E9"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33 43C33 44.6569 31.6569 46 30 46C28.3431 46 27 44.6569 27 43C27 41.3431 28.3431 40 30 40C31.6569 40 33 41.3431 33 43ZM63 43C63 44.6569 61.6569 46 60 46C58.3431 46 57 44.6569 57 43C57 41.3431 58.3431 40 60 40C61.6569 40 63 41.3431 63 43ZM37.9152 59.8545C37.1972 60.2678 36.2801 60.0209 35.8668 59.3029C35.4534 58.585 35.7004 57.6679 36.4183 57.2546C39.3867 55.5455 47.0985 53.4341 55.4995 57.6005C56.2417 57.9686 56.5449 58.8686 56.1768 59.6108C55.8088 60.353 54.9087 60.6562 54.1666 60.2882C46.8001 56.6348 40.1545 58.5651 37.9152 59.8545Z"
          fill="#D0CDD4" />
      </svg>
    </div>

    <h2>Oops, an error has occurred</h2>

    <ng-template [ngTemplateOutlet]="complete"></ng-template>
  </div>
</ng-template>

<ng-template #reviewListingsV2>
  <ng-container *ngIf="reviewListingsStage === ReviewListingsStage.ReviewListings">
    <ng-template [ngTemplateOutlet]="reviewListingsV2ReviewListingsStage"></ng-template>
  </ng-container>

  <ng-container *ngIf="reviewListingsStage === ReviewListingsStage.ConfirmListings">
    <ng-template [ngTemplateOutlet]="reviewListingsV2ConfirmListingsStage"></ng-template>
  </ng-container>
</ng-template>

<ng-template #reviewListingsV2ReviewListingsStage>
  <div fxLayout="column" fxLayoutGap="24px" *ngIf="listingReviews$ | async as listingReviews">
    <section fxLayout="column" fxLayoutGap="20px">
      <h2>
        Awesome! We found
        <strong>
          {{ listingReviews.meta.total_listings }} {{ 'listings' | pluralize: listingReviews.meta.total_listings }}
        </strong>
        🎉
      </h2>
      <span>
        Let's get those added to {{ 'CORE.PRODUCT_NAME' | transloco }}. Mute any listings that you do not want to manage
        in {{ 'CORE.PRODUCT_NAME' | transloco }}.
      </span>
    </section>

    <!-- TODO: Uncomment this once we can properly merge properties -->
    <!-- <section>
      <sbnb-note
        [type]="NoteType.Custom"
        [iconSrc]="'/assets/iconography/hyperlink.svg'"
        [content]="'Merge listings belonging to the same property'">
        <span class="note-banner__slot">
          Already have this listing added to Hospitable.com for another channel? Merge identical listings into one
          property to sync their calendars — no more double bookings!
          <br />
          <a
            class="grass-darker"
            href="https://my.hospitable.com/support-documentation/article/4587931-what-are-properties"
            target="_blank">
            Learn more about properties
          </a>
        </span>
      </sbnb-note>
    </section> -->

    <section>
      <div class="listings-container">
        <div class="listing-row" fxLayout fxLayoutAlign="space-between center">
          <span class="night text__medium">Listing</span>
          <span class="night text__medium action--label">Action</span>
        </div>
        <ng-container *ngFor="let listing of listingReviews.listings">
          <div
            class="listing-row"
            [class.bg-smoke-lighter]="listing.muted"
            fxLayout
            fxLayoutAlign="start center"
            fxLayoutGap="12px">
            <img fxHide.lt-md fxFlex="24px 0 0" class="listing-img" [src]="listing.picture" />

            <span fxFlex class="night text__medium" [class.strikethrough]="listing.muted">
              {{ listing.name }}
            </span>

            <ng-container *ngIf="perms$.permissions | async as perms">
              <!-- @TODO we need to uncomment this once we can properly merge properties -->
              <!-- <ng-container *ngIf="updateListingReviewsFormEntity$ | async as updateListingReviewsFormEntity"> -->
              <ng-container *ngIf="{ merge_candidate: null } as updateListingReviewsFormEntity">
                <sbnb-merge-match-dropdown
                  [selectedOption]="
                    updateListingReviewsFormEntity[listing.property_id]
                      ? updateListingReviewsFormEntity[listing.property_id]['action']
                      : UpdatePropertyOption.CreateNewProperty
                  "
                  [properties]="properties$ | async"
                  [hidePropertiesWithIds]="[listing.property_id]"
                  [isMuted]="listing.muted"
                  [showFocusBorderIfMergeCandidate]="true"
                  (selectedOptionChanged)="
                    updateForm(listing.listing_id, listing.property_id, $event)
                  "></sbnb-merge-match-dropdown>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </section>

    <ng-container
      [ngTemplateOutlet]="continueTemplate"
      [ngTemplateOutletContext]="{
        listingReviewsHasCohosted: listingReviewsHasCohosted$ | async
      }"></ng-container>
  </div>
</ng-template>

<ng-template #reviewListingsV2ConfirmListingsStage>
  <ng-container [ngSwitch]="updateListingReviewsCombinedLoadingStates$ | async">
    <ng-container *ngSwitchCase="LoadingState.Pending">
      <div fxLayout style="margin-bottom: 24px">
        <span fxFlex style="margin-left: 16px">Getting everything ready..</span>
      </div>

      <div fxLayout style="margin-bottom: 24px; align-items: center; justify-content: center">
        <mat-spinner fxLayout fxLayoutAlign="center" [diameter]="30"></mat-spinner>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="LoadingState.Error">
      <ng-template [ngTemplateOutlet]="reviewListingsError"></ng-template>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <ng-container *ngIf="listingReviewsToBeMerged$ | async as listingReviewsToBeMerged">
        <div fxLayout="column" *ngIf="listingReviewsToBeMerged.length > 0">
          <section fxLayout="column" fxLayoutGap="20px">
            <h2>Confirm listing{{ listingReviewsToBeMerged.length > 1 ? 's' : '' }} to be merged</h2>
          </section>

          <section fxLayout="column" fxLayoutGap="20px">
            <sbnb-note
              [type]="NoteType.Info"
              [content]="
                '<p style=margin-top:0;margin-bottom:0;margin-left:12px>
                        Only merge identical listings which can be managed under a single calendar.
                        If you have multiple listings at the same address, but which can be booked separately, do not
                        merge the listings
                        <br/>
                        <a class=grass-darker pointer>Learn more about properties </a>
                        </p>'
              "></sbnb-note>
          </section>

          <section>
            <div class="listings-container">
              <div class="listing-row" fxLayout fxLayoutAlign="start center">
                <span fxFlex class="night text__medium">
                  {{ listingReviewsToBeMerged.length }}
                  listing{{ listingReviewsToBeMerged.length > 1 ? 's' : '' }} to be merged
                </span>
              </div>
              <ng-container *ngIf="listingReviewsListingEntities$ | async as listingEntities">
                <ng-container *ngIf="propertyEntities$ | async as propertyEntities">
                  <ng-container *ngFor="let listingToBeMerged of listingReviewsToBeMerged">
                    <div class="listing-row merge-border-left" fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
                      <img
                        fxFlex="24px 0 0"
                        class="listing-img"
                        [src]="listingEntities[listingToBeMerged.listingId].picture" />
                      <span fxFlex class="night text__medium">
                        {{ listingEntities[listingToBeMerged.listingId].name }}
                      </span>
                    </div>

                    <div
                      class="listing-row merge-border-left"
                      style="margin-bottom: 24px"
                      fxLayout
                      fxLayoutAlign="start center"
                      fxLayoutGap="12px">
                      <img
                        fxFlex="24px 0 0"
                        class="listing-img"
                        [src]="
                          propertyEntities[listingToBeMerged.action.replace(UpdatePropertyOption.MergeProperty, '')]
                            .picture
                        " />
                      <span fxFlex class="night text__medium">
                        {{
                          propertyEntities[listingToBeMerged.action.replace(UpdatePropertyOption.MergeProperty, '')]
                            .name
                        }}
                      </span>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </section>
        </div>
      </ng-container>

      <ng-container *ngIf="listingReviewsToBeMuted$ | async as listingReviewsToBeMuted">
        <div fxLayout="column" style="margin-top: 24px" *ngIf="listingReviewsToBeMuted.length > 0">
          <section fxLayout="column" fxLayoutGap="20px">
            <h2>Confirm listing{{ listingReviewsToBeMuted.length > 1 ? 's' : '' }} to be muted</h2>
          </section>

          <section fxLayout="column" fxLayoutGap="20px">
            <sbnb-note
              [type]="NoteType.Info"
              [content]="
                '<p style=margin-top:0;margin-bottom:0>
                           Muted properties are excluded from Hospitable services.
                           You are not billed for muted properties. You can unmute the property at any time
                           from the Property page.
                            <br/>
                            <a class=grass-darker pointer>Learn more about properties </a>
                            </p>'
              "></sbnb-note>
          </section>

          <section>
            <div class="listings-container">
              <div class="listing-row" fxLayout fxLayoutAlign="start center">
                <span fxFlex class="night text__medium">
                  {{ listingReviewsToBeMuted.length }}
                  listing {{ listingReviewsToBeMuted.length > 1 ? 's' : '' }} to be muted
                </span>
              </div>
              <ng-container *ngIf="listingReviewsListingEntities$ | async as listingEntities">
                <ng-container *ngFor="let listingToBeMuted of listingReviewsToBeMuted">
                  <div class="listing-row" fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
                    <img
                      fxFlex="24px 0 0"
                      class="listing-img"
                      [src]="listingEntities[listingToBeMuted.listingId].picture" />
                    <span fxFlex class="night text__medium">
                      {{ listingEntities[listingToBeMuted.listingId].name }}
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </section>
        </div>
      </ng-container>

      <ng-container *ngIf="listingReviewsToBeUnMuted$ | async as listingReviewsToBeUnMuted">
        <div fxLayout="column" style="margin-top: 24px" *ngIf="listingReviewsToBeUnMuted.length > 0">
          <section fxLayout="column" fxLayoutGap="20px">
            <h2>Confirm listing{{ listingReviewsToBeUnMuted.length > 1 ? 's' : '' }} to be unmuted</h2>
          </section>

          <section fxLayout="column" fxLayoutGap="20px">
            <sbnb-note
              [type]="NoteType.Info"
              [content]="
                '<p style=margin-top:0;margin-bottom:0>
                                       Muted properties are excluded from Hospitable services.
                                       You are not billed for muted properties. You can mute the property at any time
                                       from the Property page.
                                        <br/>
                                        <a class=grass-darker pointer>Learn more about properties </a>
                                        </p>'
              "></sbnb-note>
          </section>

          <section>
            <div class="listings-container">
              <div class="listing-row" fxLayout fxLayoutAlign="start center">
                <span fxFlex class="night text__medium">
                  {{ listingReviewsToBeUnMuted.length }}
                  listing {{ listingReviewsToBeUnMuted.length > 1 ? 's' : '' }} to be unmuted
                </span>
              </div>
              <ng-container *ngIf="listingReviewsListingEntities$ | async as listingEntities">
                <ng-container *ngFor="let listingToBeUnMuted of listingReviewsToBeUnMuted">
                  <div class="listing-row" fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
                    <img
                      fxFlex="24px 0 0"
                      class="listing-img"
                      [src]="listingEntities[listingToBeUnMuted.listingId].picture" />
                    <span fxFlex class="night text__medium">
                      {{ listingEntities[listingToBeUnMuted.listingId].name }}
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </section>
        </div>
      </ng-container>

      <ng-container *ngIf="propertiesToBeCreated$ | async as propertiesToBeCreated">
        <div class="w-[1000px]" fxLayout="column" style="margin-top: 24px" *ngIf="propertiesToBeCreated.length > 0">
          <section fxLayout="column" fxLayoutGap="20px">
            <h2>
              Confirm
              {{ 'properties' | pluralize: propertiesToBeCreated.length }} to be imported
            </h2>
          </section>

          <section>
            <div class="listings-container">
              <div class="listing-row" fxLayout fxLayoutAlign="start center">
                <span fxFlex class="night text__medium">
                  {{ propertiesToBeCreated.length }}
                  {{ 'properties' | pluralize: propertiesToBeCreated.length }}
                  to be imported
                </span>
              </div>
              <ng-container *ngIf="listingReviewsListingEntities$ | async as listingEntities">
                <ng-container *ngFor="let propertyToBeCreated of propertiesToBeCreated">
                  <div class="listing-row" fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
                    <img
                      fxFlex="24px 0 0"
                      class="listing-img"
                      [src]="listingEntities[propertyToBeCreated.listingId].picture" />
                    <span fxFlex class="night text__medium">
                      {{ listingEntities[propertyToBeCreated.listingId].name }}
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </section>
        </div>
      </ng-container>

      <ng-container
        [ngTemplateOutlet]="continueAndBackTemplate"
        [ngTemplateOutletContext]="{
          listingReviewsHasCohosted: listingReviewsHasCohosted$ | async
        }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #complete>
  <div
    fxLayout
    fxLayoutGap="18px"
    fxLayoutAlign="end center"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="center stretch">
    <button mat-flat-button [routerLink]="['/accounts/new/complete']">Continue</button>
  </div>
</ng-template>

<ng-template #continueTemplate let-hasCohosted="listingReviewsHasCohosted">
  <div
    fxLayout
    fxLayoutGap="18px"
    fxLayoutAlign="end center"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="center stretch">
    <button mat-flat-button [disabled]="saving" [loading]="saving" (click)="continue(hasCohosted)">Continue</button>
  </div>
</ng-template>

<ng-template #continueAndBackTemplate let-hasCohosted="listingReviewsHasCohosted">
  <div
    fxLayout
    fxLayoutGap="18px"
    style="margin-top: 24px"
    fxLayoutAlign="space-between center"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="center stretch">
    <button (click)="reviewListingsStage = ReviewListingsStage.ReviewListings">Back</button>

    <button mat-flat-button (click)="save(hasCohosted)">Continue</button>
  </div>
</ng-template>
